import moment from "moment-timezone";

const PST_TIMEZONE = 'America/Los_Angeles';

export function useDisplayFormatters() {
	const getToggleColorWarning = (val: boolean) => val === true ? 'warning' : 'success';
	const getToggleColorError = (val: boolean) => val === true ? 'error' : 'success';
	const toYesNoLabel = (val: string) => val === 'Y' ? 'Yes' : 'No';
	const toYesNoLabelBoolean = (val: boolean) => val ? 'Yes' : 'No';

	const formatDate = (dateStr?: string | Date, dateFormat = 'MM/DD/YYYY'): string => {
		if (!dateStr) return '—';

		return moment.tz(dateStr, PST_TIMEZONE).format(dateFormat);
	};

	const formatDateRelative = (dateStr?: string | Date): string => {
		if (!dateStr) return '—';

		return moment.tz(dateStr, PST_TIMEZONE).fromNow();
	};

	const formatDateTime = (dateStr?: string | Date, dateFormat = 'YYYY-MM-DD HH:mm:ss'): string => {
		if (!dateStr) return '—';

		return moment.tz(dateStr, PST_TIMEZONE).format(dateFormat);
	};

	const compareDates = (a?: string | Date, b?: string | Date): number => {
		return moment.tz(a, PST_TIMEZONE).valueOf() - moment.tz(b, PST_TIMEZONE).valueOf();
	};

	return {
		getToggleColorWarning,
		getToggleColorError,
		formatDate,
		formatDateRelative,
		formatDateTime,
		compareDates,
		toYesNoLabel,
		toYesNoLabelBoolean
	};
}
